import React from "react";
import {
  BootstrapTable,
  TableHeaderColumn,
  ExportCSVButton,
} from "react-bootstrap-table";
import {
  CustomExportCSVButton,
  addCreditsOnExportToCSV,
} from "Components/Tables/Common";
import config from "Config";

const numberFormatter = (cell, row) => cell.toLocaleString();
const pctFormatter = (cell, row) => `${cell}%`;
const csvFormatter = (cell, row) => Number(cell);

const SummaryInfoGraphicForGeo = ({ data, geo, layout }) => {
  const colClass = (first = false, _layout = layout) =>
    _layout == "vertical"
      ? `col-12 border-bottom pt-3 pb-3 ${first ? "border-top" : ""}`
      : `col border-right ${first ? "border-left" : ""}`;

  let rowClass = layout == "vertical" ? "row" : "row text-center";

  return (
    <div id="summary-info-graphic" className={rowClass}>
      <div className={colClass(true)}>
        <h2 className="display-8">
          <i className="fa fa-users fa-fw" aria-hidden="true"></i>{" "}
          {data.geo_total_all.toLocaleString()}
        </h2>
        <div>
          <strong>{geo.replace(/ \(\w\)$/, "")}'s total population</strong>
        </div>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-venus fa-fw" aria-hidden="true"></i>{" "}
          {data.females.toLocaleString()}
        </h3>

        <h3 className="display-8">
          <i className="fa fa-mars fa-fw" aria-hidden="true"></i>{" "}
          {data.males.toLocaleString()}
        </h3>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-map-marker fa-fw" aria-hidden="true"></i>{" "}
          {data.birthplace_top_name.toLocaleString()}
        </h3>
        <div>
          most common birthplace (excl. Australia) with{" "}
          <strong>{data.birthplace_top_count.toLocaleString()}</strong>{" "}
          respondents
        </div>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-birthday-cake fa-fw" aria-hidden="true"></i>{" "}
          {data.tableRows
            .find((r) => r.id === "Born in Australia")
            .geo_total.toLocaleString()}
        </h3>
        <div>
          <strong>Born in Australia</strong>
        </div>
      </div>
    </div>
  );
};

const SummaryInfoGraphicForCommunity = ({
  data,
  community,
  community_value,
  layout,
}) => {
  const colClass = (first = false, _layout = layout) =>
    _layout == "vertical"
      ? `col-12 border-bottom pt-3 pb-3 ${first ? "border-top" : ""}`
      : `col border-right ${first ? "border-left" : ""}`;

  let rowClass = layout == "vertical" ? "row" : "row text-center";

  return (
    <div id="summary-info-graphic" className={rowClass}>
      <div className={colClass(true)}>
        <h2 className="display-8">
          <i className="fa fa-users fa-fw" aria-hidden="true"></i>{" "}
          {data.geo_total_all.toLocaleString()}
        </h2>
        <div>
          <strong>
            Total population for {community}: {community_value}
          </strong>
        </div>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-venus fa-fw" aria-hidden="true"></i>{" "}
          {data.females.toLocaleString()}
        </h3>

        <h3 className="display-8">
          <i className="fa fa-mars fa-fw" aria-hidden="true"></i>{" "}
          {data.males.toLocaleString()}
        </h3>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-map-marker fa-fw" aria-hidden="true"></i>{" "}
          {data.birthplace_top_name.toLocaleString()}
        </h3>
        <div>
          most common birthplace (excl. Australia) with{" "}
          <strong>{data.birthplace_top_count.toLocaleString()}</strong>{" "}
          respondents
        </div>
      </div>

      <div className={colClass()}>
        <h3 className="display-8">
          <i className="fa fa-birthday-cake fa-fw" aria-hidden="true"></i>{" "}
          {data.tableRows
            .find((r) => r.id === "Born in Australia")
            .geo_total.toLocaleString()}
        </h3>
        <div>
          <strong>Born in Australia</strong>
        </div>
      </div>
    </div>
  );
};

const options = {
  exportCSVBtn: CustomExportCSVButton,
};

const SummaryTableForGeo = (props) => (
  <div>
    {props.geo_aggregation === "ste" ? (
      <BootstrapTable
        data={props.data.tableRows}
        striped={true}
        hover={true}
        csvFileName={`${props.downloadDate}-${props.geo}.csv`}
        exportCSV
        options={{
          ...options,
          onExportToCSV: addCreditsOnExportToCSV(
            props.data.tableRows,
            props.year
          ),
        }}
        version="4"
      >
        <TableHeaderColumn
          headerTitle={true}
          dataField="id"
          isKey={true}
          dataAlign="left"
          dataSort={true}
          csvHeader="Statistic"
          width="34%"
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          Statistic
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="geo_total"
          dataSort={true}
          dataFormat={numberFormatter}
          csvHeader={`${props.geo} Total`}
          csvFormatter={csvFormatter}
        >
          {props.geo}
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="geo_pct"
          dataSort={true}
          dataFormat={pctFormatter}
          csvHeader={`${props.geo} %`}
          csvFormatter={csvFormatter}
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          {props.geo} %
        </TableHeaderColumn>
      </BootstrapTable>
    ) : (
      <BootstrapTable
        data={props.data.tableRows}
        striped={true}
        hover={true}
        csvFileName={`${props.downloadDate}-${props.geo}.csv`}
        exportCSV
        options={options}
        version="4"
      >
        <TableHeaderColumn
          headerTitle={true}
          dataField="id"
          isKey={true}
          dataAlign="left"
          dataSort={true}
          csvHeader="Statistic"
          width="34%"
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          Statistic
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="geo_total"
          dataSort={true}
          dataFormat={numberFormatter}
          csvHeader={`${props.geo} Total`}
          csvFormatter={csvFormatter}
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          {props.geo}
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="geo_pct"
          dataSort={true}
          dataFormat={pctFormatter}
          csvHeader={`${props.geo} %`}
          csvFormatter={csvFormatter}
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          {props.geo} %
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="state_total"
          dataSort={true}
          dataFormat={numberFormatter}
          csvHeader="State Total"
          csvFormatter={csvFormatter}
          width="15%"
          tdStyle={{
            whiteSpace: "normal",
          }}
          thStyle={{
            whiteSpace: "normal",
          }}
        >
          State
        </TableHeaderColumn>
        <TableHeaderColumn
          headerTitle={true}
          dataField="state_pct"
          dataSort={true}
          dataFormat={pctFormatter}
          csvHeader="State %"
          csvFormatter={csvFormatter}
          width="15%"
        >
          State %
        </TableHeaderColumn>
      </BootstrapTable>
    )}
  </div>
);

const SummaryTableForCommunity = (props) => (
  <div>
    <BootstrapTable
      data={props.data.tableRows}
      striped={true}
      hover={true}
      csvFileName={`${props.downloadDate}-${props.community_value}.csv`}
      exportCSV
      options={options}
      version="4"
    >
      <TableHeaderColumn
        headerTitle={true}
        dataField="id"
        isKey={true}
        dataAlign="left"
        dataSort={true}
        csvHeader="Statistic"
        width="34%"
        tdStyle={{
          whiteSpace: "normal",
        }}
        thStyle={{
          whiteSpace: "normal",
        }}
      >
        Statistic
      </TableHeaderColumn>
      <TableHeaderColumn
        headerTitle={true}
        dataField="geo_total"
        dataSort={true}
        dataFormat={numberFormatter}
        csvHeader={`${props.community_value} Total`}
        csvFormatter={csvFormatter}
        tdStyle={{
          whiteSpace: "normal",
        }}
        thStyle={{
          whiteSpace: "normal",
        }}
      >
        {props.community_value}
      </TableHeaderColumn>
      <TableHeaderColumn
        headerTitle={true}
        dataField="geo_pct"
        dataSort={true}
        dataFormat={pctFormatter}
        csvHeader={`${props.geo} %`}
        csvFormatter={csvFormatter}
        tdStyle={{
          whiteSpace: "normal",
        }}
        thStyle={{
          whiteSpace: "normal",
        }}
      >
        {props.community_value} %
      </TableHeaderColumn>
      <TableHeaderColumn
        headerTitle={true}
        dataField="state_total"
        dataSort={true}
        dataFormat={numberFormatter}
        csvHeader="State Total"
        csvFormatter={csvFormatter}
        width="15%"
        tdStyle={{
          whiteSpace: "normal",
        }}
        thStyle={{
          whiteSpace: "normal",
        }}
      >
        State
      </TableHeaderColumn>
      <TableHeaderColumn
        headerTitle={true}
        dataField="state_pct"
        dataSort={true}
        dataFormat={pctFormatter}
        csvHeader="State %"
        csvFormatter={csvFormatter}
        width="15%"
      >
        State %
      </TableHeaderColumn>
    </BootstrapTable>
  </div>
);
const Summary = ({
  showFor,
  data,
  geo,
  geo_aggregation,
  community,
  community_value,
  hide_table,
  year,
}) => {
  const layout = hide_table ? "vertical" : "horizontal";
  const downloadDate = new Date().toISOString().split("T")[0];

  return (
    <div>
      <div>
        {showFor === "geo_aggregation" ? (
          <SummaryInfoGraphicForGeo
            data={data}
            forState={geo_aggregation === "ste"}
            geo={geo_aggregation === "ste" ? config.admin_state_name : geo}
            layout={layout}
          />
        ) : (
          <div>
            <SummaryInfoGraphicForCommunity
              data={data}
              community={community}
              community_value={community_value}
              layout={layout}
            />
          </div>
        )}
      </div>
      {!hide_table ? (
        showFor === "geo_aggregation" ? (
          <SummaryTableForGeo
            downloadDate={downloadDate}
            data={data}
            geo={geo}
            geo_aggregation={geo_aggregation}
            year={year}
          ></SummaryTableForGeo>
        ) : (
          <SummaryTableForCommunity
            downloadDate={downloadDate}
            data={data}
            community={community}
            community_value={community_value}
            year={year}
          ></SummaryTableForCommunity>
        )
      ) : null}
    </div>
  );
};
module.exports = { "Population Composition": Summary };



// WEBPACK FOOTER //
// ./components/Tables/KeyStatistics.js